import React, { useState } from "react";
import {
  Button,
  Divider,
  TableAdv,
  PageHeader,
  PageTitle,
} from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";
import AddDependent from "./Dependents/AddDependent";
import AddDependentPassport from "./Dependents/AddDependentPassport";
import AddDependentI94 from "./Dependents/AddDependentI94";
import ViewSsn from "./Dependents/ViewSsn";

const Dependents = () => {
  const [addDependent, setAddDependent] = useState(false);
  const [viewSsn, setViewSsn] = useState(false);
  const [dependentPassport, setDependentPassport] = useState(false);
  const [dependentI94, setDependentI94] = useState(false);

  const tableData = [];
  const columns = [
    {
      key: "dependentName",
      label: "Dependent Name",
    },
    {
      key: "relationship",
      label: "Relationship",
    },

    {
      key: "dateOfBirth",
      label: "Date of Birth",
      render: (row) => dateFormator(row.dateOfBirth, "month-day-year"),
    },
    {
      key: "dependentGender",
      label: "Dependent Gender",
    },
    {
      key: "visaType",
      label: "Visa Type",
    },
    {
      key: "ssn",
      label: "SSN",
    },

    {
      key: "attachmentName",
      label: "Attachment Name",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="link"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);
  const passporttableData = [];
  const passportcolumns = [
    {
      key: "dependent",
      label: "Dependent",
    },
    {
      key: "passportNumber",
      label: "Passport Number",
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "placeOfIssue",
      label: "Place of Issue",
    },

    {
      key: "issuedDate",
      label: "Issued Date",
      render: (row) => dateFormator(row.issuedDate, "month-day-year"),
    },
    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.issuedDate, "month-day-year"),
    },

    {
      key: "documents",
      label: "Documents",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="link"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const passportmappedRows = mapTableRows(passporttableData, passportcolumns);
  const i94tableData = [];
  const i94columns = [
    {
      key: "dependent",
      label: "Dependent",
    },
    {
      key: "i94Number",
      label: "I-94 Number",
    },

    {
      key: "dateOfLastArrival",
      label: "Date of Last Arrival",
      render: (row) => dateFormator(row.dateOfLastArrival, "month-day-year"),
    },
    {
      key: "statusExpiryDate",
      label: "Status Expiry Date",
      render: (row) => dateFormator(row.statusExpiryDate, "month-day-year"),
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "priorityDate",
      label: "Priority Date",
      render: (row) => dateFormator(row.statusExpiryDate, "month-day-year"),
    },

    {
      key: "documents",
      label: "Documents",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="link"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const i94mappedRows = mapTableRows(i94tableData, i94columns);
  return (
    <div>
      <div className="mt-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"DEPENDENTS DETAIL"} tag="p" />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                title="Add"
                size="sm"
                icon={"ADD"}
                iconPosition={"before"}
                onClick={() => setAddDependent(true)}
              />
              <Button
                title="View SSN"
                size="sm"
                iconPosition={"before"}
                onClick={() => setViewSsn(true)}
              />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="my-4">
        <TableAdv tableId={`immigration_h1b_h1bview_dependents_dependentsdetailtable`} rows={mappedRows} columns={columns} hideToolBar />
      </div>
      <div className="mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"DEPENDENTS PASSPORT DETAIL"} tag="p" />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                title="Add"
                size="sm"
                icon={"ADD"}
                iconPosition={"before"}
                onClick={() => setDependentPassport(true)}
              />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_dependents_dependentspassportdetailtable`}
          rows={passportmappedRows}
          columns={passportcolumns}
          hideToolBar
        />
      </div>
      <div className="mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"DEPENDENTS I-94 DETAIL"} tag="p" />
            </div>
          }
          RightSection={
            <div className="flex gap-3">
              <Button
                title="Add"
                size="sm"
                icon={"ADD"}
                iconPosition={"before"}
                onClick={() => setDependentI94(true)}
              />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_dependents_dependentsi94detailtable`} rows={i94mappedRows} columns={i94columns} hideToolBar />
      </div>
      <AddDependent
        isOpen={addDependent}
        onClose={() => setAddDependent(false)}
      />
      <AddDependentPassport
        isOpen={dependentPassport}
        onClose={() => setDependentPassport(false)}
      />
      <AddDependentI94
        isOpen={dependentI94}
        onClose={() => setDependentI94(false)}
      />
      <ViewSsn isOpen={viewSsn} onClose={() => setViewSsn(false)} />
    </div>
  );
};

export default Dependents;
